module.exports = __webpack_public_path__ + "static/media/mudeyPurpleProYellow1.298c4d17.png";